import { ReactNode, useContext, useMemo } from 'react';
import { HeadingContext } from './HeadingContext';

interface Props {
  children: ReactNode;
}

export function HeadingContextProvider(props: Props) {
  const context = useContext(HeadingContext);
  const value = useMemo(
    () => ({
      level: (context?.level ?? 0) + 1,
    }),
    [context?.level]
  );

  return (
    <HeadingContext.Provider value={value}>
      {props.children}
    </HeadingContext.Provider>
  );
}
